import { arrayWithoutSubset, setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { SuggestedLeadersDismissFulfilledAction } from '../../domains/suggestedLeaderDismiss/actions.types';
import type {
  SuggestedLeadersLoadAction,
  SuggestedLeadersLoadFulfilledAction,
  SuggestedLeadersLoadMoreAction,
  SuggestedLeadersLoadMoreFulfilledAction,
} from '../../domains/suggestedLeaders/actions.types';

import type { ViewerSuggestedLeaders } from './types';

export const initialState: ViewerSuggestedLeaders = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const loadMoreSuggestedLeaderFulfilled = (
  state: ViewerSuggestedLeaders,
  action: SuggestedLeadersLoadMoreFulfilledAction
) => {
  if (!state.fulfilled) {
    return setFulfilled({
      suggestedLeaderIds: action.payload.entities.viewerSuggestedLeaders.suggestedLeaderIds,
      dismissedSuggestedLeaderIds: [],
    });
  }

  return {
    ...state,
    fulfilled: {
      ...state.fulfilled,
      suggestedLeaderIds: [
        ...new Set([
          ...state.fulfilled.suggestedLeaderIds,
          ...arrayWithoutSubset(
            action.payload.entities.viewerSuggestedLeaders.suggestedLeaderIds,
            state.fulfilled.dismissedSuggestedLeaderIds
          ),
        ]),
      ],
    },
  };
};

const dismissSuggestedLeaderFulfilled = (
  state: ViewerSuggestedLeaders,
  action: SuggestedLeadersDismissFulfilledAction
) => {
  if (!state.fulfilled) {
    return state;
  }

  return {
    ...state,
    fulfilled: {
      suggestedLeaderIds: state.fulfilled.suggestedLeaderIds.filter((id) => id !== action.payload.userId),
      dismissedSuggestedLeaderIds: [...state.fulfilled.dismissedSuggestedLeaderIds, action.payload.userId],
    },
  };
};

const loadSuggestedLeaderFulfilled = (state: ViewerSuggestedLeaders, action: SuggestedLeadersLoadFulfilledAction) => {
  if (!state.fulfilled) {
    return setFulfilled({ ...action.payload.entities.viewerSuggestedLeaders, dismissedSuggestedLeaderIds: [] });
  }

  return {
    ...state,
    fulfilled: {
      ...state.fulfilled,
      suggestedLeaderIds: arrayWithoutSubset(
        action.payload.entities.viewerSuggestedLeaders.suggestedLeaderIds,
        state.fulfilled.dismissedSuggestedLeaderIds
      ),
    },
  };
};

export type SuggestedLeadersAction =
  | SuggestedLeadersLoadAction
  | SuggestedLeadersLoadMoreAction
  | SuggestedLeadersDismissFulfilledAction;

const reducer: Reducer<ViewerSuggestedLeaders, SuggestedLeadersAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SUGGESTED_LEADERS.LOAD_PENDING':
      return setPending();
    case 'SUGGESTED_LEADERS.LOAD_FULFILLED':
      return loadSuggestedLeaderFulfilled(state, action);
    case 'SUGGESTED_LEADERS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'SUGGESTED_LEADERS.LOAD_MORE_FULFILLED':
      return loadMoreSuggestedLeaderFulfilled(state, action);
    case 'SUGGESTED_LEADERS.DISMISS_FULFILLED':
      return dismissSuggestedLeaderFulfilled(state, action);
    default:
      return state;
  }
};

export default reducer;
